module.exports = require("@bechtel/client-assets/dist/images/arc-stryker-blue-label.svg");